<template>
    <div>
        <b-col v-if="isServiceOrTask(itemTypeId)" class="d-flex py-3">
            <page-actions :dropdown-actions="otherActions" control-size="sm" />
        </b-col>
        <slot></slot>
        <div class="responsive-table w-100 overflow-auto">
            <table ref="selectableTable" class="table b-table b-table-selectable b-table-select-multi">
                <thead>
                    <tr>
                        <th v-for="field in fields" :key="field.key">
                            <span v-if="!!field.label">
                                <span v-html="field.label"></span>
                            </span>
                            <span v-else>
                                <div v-if="fields.includes('service_check')">
                                    <input type="checkbox" v-model="serviceSelectAll" :disabled="isCompleted"
                                        :checked="updateSelectAll" @change="toggleServiceSelectAll()" />
                                </div>
                                <div v-if="fields.includes('task_check')">
                                    <input type="checkbox" v-model="taskSelectAll" :disabled="isCompleted"
                                        :checked="updateSelectAll" @change="toggleAllTaskRow()" />
                                </div>
                            </span>
                        </th>
                    </tr>
                </thead>
                <draggable tag="tbody" :class="'table' + tableIndex" @end="onDragEnd" :options="draggableOptions"
                    class="draggable-table">
                    <!-- @end="onDragEnd" -->
                    <tr v-for="item in arrangedItems" :key="item.hash" class="draggable-item">
                        <td v-if="isServiceOrTask(item.order_item_type_id)">
                            <b-form-checkbox v-if="isService(item.order_item_type_id)" :checked="selectedItems.some(
                                index => index.id == item.id
                            )
                                " :disabled="isCompleted || !item.id"
                                @change="toggleServiceRow(item)"></b-form-checkbox>
                            <b-form-checkbox v-if="isTask(item.order_item_type_id)" :checked="selectedItems.some(
                                index => index.id == item.id
                            )
                                " :disabled="isCompleted || !item.id" @change="toggleTaskRow(item)"></b-form-checkbox>
                        </td>
                        <td>
                            <div class="d-flex justify-content-start">
                                <button class="me-2 pink-button" @click="$emit('view-item', item.hash)">
                                    <img src="@/assets/images/icon/view.svg" alt="View" />
                                </button>
                                <button :disabled="item.is_template_item" @click="deleteItem(item.hash)" v-if="hasPermissionDelete && !order.completed
                                    " class="pink-button">
                                    <img src="@/assets/images/icon/delete.svg" alt="Delete" />
                                </button>
                            </div>
                        </td>
                        <td>{{ item.name }}</td>
                        <td>
                            <span v-if="item.description" style="font-weight: bold">
                                {{ item.description }}
                            </span>
                            <ul class="dashed">
                                <li v-if="item.task_notes">
                                    {{ $translate('notes') }}
                                    <span style="font-weight: bold"> </span>
                                    {{ item.task_notes }}
                                </li>
                                <li v-if="item.task_value">
                                    {{ $translate('value') }}
                                    <span style="font-weight: bold"> </span>
                                    {{ item.task_value }}
                                </li>
                                <li v-if="item.assets && item.assets.length" v-html="displayAssets(item.assets)"></li>
                            </ul>
                        </td>
                        <td v-if="!isTask(item.order_item_type_id)">
                            {{ item.uom }}
                        </td>
                        <td>{{ item.quantity }}</td>
                        <td v-if="!isTask(item.order_item_type_id)">
                            {{ item.price | currency }}
                        </td>
                        <td v-if="!isTask(item.order_item_type_id)">
                            {{ calculateItemTax(item) | currency }}
                        </td>
                        <td v-if="!isTask(item.order_item_type_id)">
                            {{ calculateItemCost(item) | currency }}
                        </td>
                        <td v-if="isServiceOrTask(item.order_item_type_id)">
                            <b-form-checkbox value="true" unchecked-value="false" :checked="!!item.task_checked" disabled>
                            </b-form-checkbox>
                        </td>
                    </tr>
                </draggable>
            </table>
        </div>
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import PageActions from '@/components/PageActions.vue'
import permissionsMixins from '@/mixins/permissionsMixins'
import draggable from 'vuedraggable'

export default {
    components: {
        PageActions,
        draggable,
    },
    name: 'orders-displayOrderItems',
    data: () => ({
        criteria: null,
        draggableOptions: {
            animation: 300,
        },
        type: null,
        selectedItems: [],
        isAssignment: true,
        serviceSelectAll: false,
        taskSelectAll: false,
        text: 'Sample Text',
    }),
    props: [
        'filteredItems',
        'items',
        'viewMode',
        'customerAssets',
        'itemTypeId',
        'tableIndex',
    ],

    mixins: [popupMixins, permissionsMixins],
    filters: {
        displayTypeName(id, itemTypes) {
            return (itemTypes.find(x => x.id == id) || {}).name
        },
        formatLocation(s) {
            s = s || {}
            s.location = s.location || {}
            return `${s.name}, ${s.location.address1}, ${s.location.city}`
        },
        currency: num => {
            num = parseFloat(num)
            try {
                return num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
            } catch (err) {
                return '0.00'
            }
        },
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        },
    },
    computed: {
        otherActions() {
            const actions = []
            if (this.isServiceOrTask(this.itemTypeId)) {
                const updateDisabled = !(
                    this.selectedItems.length > 0 && this.hasPermissionUpdate && !this.viewMode
                )
                actions.push({
                    action: () => this.bulkCheckoff(),
                    text: this.$translate('bulk_checkoff'),
                    disabled: updateDisabled,
                    dropdownButtonClass: 'w-auto h-auto',
                })
            }
            return actions
        },
        arrangedItems() {
            return this.filteredItems
                .slice()
                .sort((a, b) => a.display_order - b.display_order)
        },
        isCompleted() {
            console.log('orders', this.$store.state.orders.item.completed)
            return !!this.$store.state.orders.item.completed
        },
        order() {
            const order = this.$store.state.orders.item

            return { ...(order || {}) }
        },
        serviceItems() {
            const { isService } = this
            return this.items.filter(x => isService(x.order_item_type_id))
        },
        taskItems() {
            const { isTask } = this
            return this.items.filter(x => isTask(x.order_item_type_id))
        },
        itemTypes() {
            return this.$store.state.itemType.items
        },

        options() {
            return [
                { text: 'Assignment', value: true },
                { text: 'Check-Off', value: false },
            ]
        },
        fields() {
            const _fields = [
                { key: 'id', label: this.$translate('actions'), stickyColumn: true },
                { key: 'name', label: this.$translate('name') },
                { key: 'details', label: this.$translate('details') },
            ]
            const task_check_field = ['task_check']
            const service_check_field = ['service_check']

            const product_fields = [
                { key: 'uom', label: this.$translate('uom') },
                { key: 'quantity', label: this.$translate('quantity') },
                {
                    key: 'price',
                    label: this.$translate('price'),
                    thClass: 'text-right',
                    tdClass: 'text-right',
                },
                {
                    key: 'tax',
                    label: this.$translate('tax'),
                    thClass: 'text-right',
                    tdClass: 'text-right',
                },
                {
                    key: 'total',
                    label: this.$translate('total'),
                    thClass: 'text-right',
                    tdClass: 'text-right',
                },
            ]
            const service_fields = [
                { key: 'uom', label: this.$translate('uom') },
                { key: 'quantity', label: this.$translate('quantity') },
                {
                    key: 'price',
                    label: this.$translate('price'),
                    thClass: 'text-right',
                    tdClass: 'text-right',
                },
                {
                    key: 'tax',
                    label: this.$translate('tax'),
                    thClass: 'text-right',
                    tdClass: 'text-right',
                },
                {
                    key: 'total',
                    label: this.$translate('total'),
                    thClass: 'text-right',
                    tdClass: 'text-right',
                },
                {
                    key: 'task_checked',
                    label: this.$translate('completed'),
                    thClass: 'text-right',
                    tdClass: 'text-right',
                },
                /* {
                    key: 'task_notes',
                    label: 'Notes',
                    thClass: 'text-right',
                    tdClass: 'text-right',
                },*/
            ]
            const task_fields = [
                /* {
                    key: 'price',
                    label: 'Price',
                    thClass: 'text-right',
                    tdClass: 'text-right',
                },
                {
                    key: 'tax',
                    label: 'Tax',
                    thClass: 'text-right',
                    tdClass: 'text-right',
                },*/
                {
                    key: 'quantity',
                    label: this.$translate('quantity'),
                    thClass: 'text-right',
                    tdClass: 'text-right',
                },
                {
                    key: 'task_checked',
                    label: this.$translate('completed'),
                    thClass: 'text-right',
                    tdClass: 'text-right',
                },
                /*  {
                    key: 'task_notes',
                    label: 'Notes',
                    thClass: 'text-right',
                    tdClass: 'text-right',
                },*/
            ]
            if (this.isTask(this.itemTypeId)) {
                _fields.unshift(...task_check_field)
                _fields.push(...task_fields)
            }
            if (this.isProduct(this.itemTypeId)) {
                _fields.push(...product_fields)
            }
            if (this.isService(this.itemTypeId)) {
                _fields.unshift(...service_check_field)
                _fields.push(...service_fields)
            }

            return _fields
        },
    },
    watch: {
        selectedItems: {
            handler() {
                this.updateSelectAll()
                this.updateTastSelectAll()
            },
            deep: true,
        },
        isAssignment: function (val) {
            this.$emit('toggleAssignment', !val)
        },
        order: {
            handler: function (_order) {
                console.log('computed---order', _order)
                this.$emit('order-status', _order.completed)
                console.log('computed---order--status', _order.completed)
            },
            deep: true,
        },
    },
    mounted() {
        console.log('this.filterdItems', this.filteredItems)
        this.$nextTick().then(() => {
            this.$emit('toggleAssignment', !this.isAssignment)
        })
    },
    methods: {
        async onDragEnd(event) {
            this.filteredItems.splice(
                event.newIndex,
                0,
                this.filteredItems.splice(event.oldIndex, 1)[0]
            )
            this.filteredItems.forEach(function (items, index) {
                items.order = index
            })
            await this.$store.dispatch(
                'orderItemStore/arrange',
                this.filteredItems
            )
        },
        toggleServiceSelectAll() {
            if (this.serviceSelectAll && this.isService(this.itemTypeId)) {
                this.selectedItems = this.filteredItems
                    .filter(item => item.id)
                    .map(item => item)
            } else {
                this.selectedItems = []
            }
        },
        updateSelectAll() {
            console.log('this.serviceItems', this.serviceItems)
            const allChecked =
                this.serviceItems.length === this.selectedItems.length
            if (allChecked && !this.serviceSelectAll) {
                this.serviceSelectAll = true
            } else if (!allChecked && this.serviceSelectAll) {
                this.serviceSelectAll = false
            }
        },
        isSelected(index) {
            return this.selectedItems.some(item => item.id == index)
        },
        toggleServiceRow(items) {
            if (this.isSelected(items.id)) {
                this.selectedItems = this.selectedItems.filter(
                    selectedIndex => selectedIndex.id !== items.id
                )
            } else {
                this.onRowSelected(items)
            }
            this.updateSelectAll()
        },
        onRowSelected(items) {
            console.log('item', items)
            this.selectedItems.push(items)
        },
        clearSelected() {
            this.selectedItems = []
        },
        updateTastSelectAll() {
            console.log('this.serviceItems', this.serviceItems)
            const allChecked =
                this.taskItems.length === this.selectedItems.length
            if (
                allChecked &&
                !this.taskSelectAll &&
                this.isTask(this.itemTypeId)
            ) {
                this.taskSelectAll = true
            } else if (
                !allChecked &&
                this.taskSelectAll &&
                this.isTask(this.itemTypeId)
            ) {
                this.taskSelectAll = false
            }
        },
        toggleTaskRow(items) {
            if (this.isSelected(items.id)) {
                this.selectedItems = this.selectedItems.filter(
                    selectedIndex => selectedIndex.id !== items.id
                )
            } else {
                this.onRowSelected(items)
            }
            this.updateSelectAll()
        },
        toggleAllTaskRow() {
            if (this.taskSelectAll && this.isTask(this.itemTypeId)) {
                this.selectedItems = this.filteredItems
                    .filter(item => item.id)
                    .map(item => item)
            } else {
                this.selectedItems = []
            }
        },
        deleteItem(hash) {
            const title = 'Delete an item?'
            const message = this.$translate(`Are delete_note`)
            this.confirmMessage(title, message)
                .then(result => {
                    if (result) {
                        this.doToast(
                            this.$translate('success'),
                            `${this.$translate('item')} ${this.$translate('delete_alert')}`,
                            'success'
                        )
                        this.$store.dispatch('orderItemStore/delete', hash)
                    }
                })
                .catch(() => {
                    this.doToast(
                        this.$translate('error'),
                        this.$translate('unable_alert'),
                        'danger'
                    )
                })
        },
        calculateItemCost(item) {
            return (
                (parseFloat(item.price) || 0) * (parseFloat(item.quantity) || 0)
            )
        },

        calculateItemTax(item) {
            let itemCost =
                (parseFloat(item.price) || 0) * (parseFloat(item.quantity) || 0)
            return (itemCost * (parseFloat(item.tax_rate) || 0)) / 100
        },

        displayAssets(ids) {
            // x.name + ' ' + x.serial_no,
            const { customerAssets } = this
            const assets = ids
                .map(id => customerAssets.find(asset => asset.id == id))
                .filter(x => !!x)

            const _html = assets.reduce((_str, asset, idx, _list) => {
                const { name, serial_no } = asset
                if (idx === 0) {
                    _str = `<b>Asset${_list.length > 0 ? 's' : ''}:</b> `
                }
                _str += `<br/>${idx + 1}&#58; ${name}${serial_no ? '-' + serial_no : ''
                    }`
                return _str
            }, '')
            return _html
        },
        fieldData(item, fieldKey) {
            console.log(
                'fieldKey',
                fieldKey,
                this.fields.find(field => field.key === fieldKey)
            )
            const field = this.fields.find(field => field.key === fieldKey)
            if (field) {
                return item[field.key]
            }
            return '' // Default value if field is not found
        },

        isProduct(itemTypeId) {
            const type = this.itemTypes.find(x => itemTypeId === x.id) || {}
            return !!(type.is_order_item && !type.is_task && !type.is_discount)
        },
        isService(itemTypeId) {
            const type = this.itemTypes.find(x => itemTypeId === x.id) || {}
            return !!(type.is_order_item && type.is_task && !type.is_discount)
        },
        isTask(itemTypeId) {
            const type = this.itemTypes.find(x => itemTypeId === x.id) || {}
            return !!(!type.is_order_item && type.is_task && !type.is_discount)
        },
        isServiceOrTask(itemTypeId) {
            const type = this.itemTypes.find(x => itemTypeId === x.id) || {}
            return !!(type.is_task && !type.is_discount)
        },

        async bulkCheckoff() {
            const title = this.$translate('bulk_checkoff')
            const message = this.$translate(`bulk_checkoff_note`)
            this.confirmMessage(title, message).then(result => {
                if (result) {
                    const bulkcheckoff = this.selectedItems.map(x => x.id)
                    const id = this.order.id
                    // console.log('orders--tests', bulkcheckofftask)
                    this.$store
                        .dispatch('orders/bulkCheckoff', { bulkcheckoff, id })
                        .then(() => {
                            this.doToast(
                                this.$translate('success'),
                                this.$translate('bulk_checkoff_successfully'),
                                'success'
                            )
                            this.clearSelected()
                            this.$store.dispatch('orders/fetchOrderItems', id)
                        })
                        .catch((err) => {
                            console.log(err.message, "bulk_checkoff_error");
                            this.doToast(
                                this.$translate('error'),
                                this.$translate('bulk_checkoff_error'),
                                'danger'
                            )
                        })
                }
            })
        },
    },
}
</script>

<style scoped>
ul {
    margin: 0;
}

ul.dashed {
    list-style-type: none;
}

ul.dashed>li {
    text-indent: -30px;
}

ul.dashed>li:before {
    content: '';
    text-indent: -30px;
}
</style>
